import { useEffect } from "react";
import {
  Main,
  WalletsShield,
  DeFiShield,
  Settings,
  LightDeFi,
  StakingRisk,
  LightNFT,
  Trash,
  LightcoreActivate,
  PartnerGuard,
  Listing,
  WalletsRadar,
} from "../Pages/index";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { StakingRiskDetails } from "../Pages/Main/StakingRiskDetails";
import { OpenPageThunk } from "../Thunks/OpenPageThunk";
import { Statistics } from "../Pages/Main/Statiustics";

export function MainRoutes() {
  const dispatch = useDispatch();

  const userData = useSelector((state) => {
    return state.profile.profileResult;
  });
  const walletShield = useSelector((state) => {
    return state.openPage.walletShield;
  });

  const lightDeFi = useSelector((state) => state.openPage.lightDeFi);

  const lightNFT = useSelector((state) => {
    return state.openPage.lightNFT;
  });

  const deFiShield = useSelector((state) => {
    return state.openPage.deFiShield;
  });

  const partnersGuard = useSelector((state) => {
    return state.openPage.partnersGuard;
  });
  const stakingRisk = useSelector((state) => {
    return state.openPage.stakingRisk;
  });

  const walletRadar = useSelector((state) => {
    return state.openPage.walletRadar;
  });
  const assetInsights = useSelector((state) => {
    return state.openPage.assetInsights;
  });

  const listingGuard = useSelector((state) => {
    return state.openPage.listeningGuard;
  });

  useEffect(() => {
    if (userData && userData.id) {
      const id = userData.id;
      dispatch(OpenPageThunk(id));
    }
  }, [userData]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route
            path="/"
            element={
              assetInsights ? (
                <Listing />
              ) : (
                <Navigate to="/lightcore-activate" state={"Assets Insight"} />
              )
            }
          />
          <Route
            path="/wallet-shield"
            element={
              walletShield ? (
                <WalletsShield />
              ) : (
                <Navigate to="/lightcore-activate" state={"Custody Shield"} />
              )
            }
          />
          <Route
            path="/defi-shield"
            element={
              deFiShield ? (
                <DeFiShield />
              ) : (
                <Navigate to="/lightcore-activate" state={"DeFi Shield"} />
              )
            }
          />
          <Route
            path="/light-defi"
            element={
              lightDeFi ? (
                <LightDeFi />
              ) : (
                <Navigate to="/lightcore-activate" state={"Light DeFi"} />
              )
            }
          />
          <Route
            path="/staking-risk"
            element={
              stakingRisk ? (
                <StakingRisk />
              ) : (
                <Navigate to="/lightcore-activate" state={"Staking Risk"} />
              )
            }
          />
          <Route
            path="/staking-risk/details/:id"
            element={
              stakingRisk ? (
                <StakingRiskDetails />
              ) : (
                <Navigate
                  to="/lightcore-activate"
                  state={"Staking Risk Details"}
                />
              )
            }
          />
          {/* <Route
            path="/staking-risk/details"
            element={
              stakingRisk ? (
                <StakingRiskDetails />
              ) : (
                <Navigate
                  to="/lightcore-activate"
                  state={"Staking Risk Details"}
                />
              )
            }
          /> */}
          <Route
            path="/light-nft"
            element={
              lightNFT ? (
                <LightNFT />
              ) : (
                <Navigate to="/lightcore-activate" state={"Light NFT"} />
              )
            }
          />
          <Route
            path="/counterparty-risk"
            element={
              partnersGuard ? (
                <PartnerGuard />
              ) : (
                <Navigate
                  to="/lightcore-activate"
                  state={"Counterparty Risk"}
                />
              )
            }
          />
          <Route
            path="/assetsinsight"
            element={
              assetInsights ? (
                <Listing />
              ) : (
                <Navigate to="/lightcore-activate" state={"Assets Insight"} />
              )
            }
          />
          <Route
            path="/wallet-radar"
            element={
              !walletRadar ? (
                <WalletsRadar />
              ) : (
                <Navigate to="/lightcore-activate" state={"Wallet Radar"} />
              )
            }
          />
          <Route path="/recycle" element={<Trash />} />
          <Route path="/lightcore-activate" element={<LightcoreActivate />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="*" element={<Navigate to="/assetsinsight" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default MainRoutes;
